{
  "actionbar.actions": "Dejanja",
  "actionbar.actionsAvailable": "Na voljo so dejanja.",
  "actionbar.clearSelection": "Počisti izbor",
  "actionbar.selected": "Izbrano: {count}",
  "actionbar.selectedAll": "Izbrano vse",
  "breadcrumbs.more": "Več elementov",
  "button.pending": "v teku",
  "calendar.invalidSelection": "Izbrano {selectedCount, plural, one {date} other {dates}} ni na voljo.",
  "combobox.noResults": "Ni rezultatov",
  "contextualhelp.help": "Pomoč",
  "contextualhelp.info": "Informacije",
  "datepicker.endTime": "Končni čas",
  "datepicker.startTime": "Začetni čas",
  "datepicker.time": "Čas",
  "dialog.alert": "Opozorilo",
  "dialog.dismiss": "Opusti",
  "dropzone.replaceMessage": "Spustite datoteko za zamenjavo",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Napaka",
  "inlinealert.notice": "Opozorilo",
  "inlinealert.positive": "Uspešno",
  "label.(optional)": "(opcijsko)",
  "label.(required)": "(obvezno)",
  "menu.moreActions": "Več možnosti",
  "notificationbadge.indicatorOnly": "Nova dejavnost",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Izberite…",
  "slider.maximum": "Največji",
  "slider.minimum": "Najmanj",
  "table.loading": "Nalaganje...",
  "table.loadingMore": "Nalaganje več vsebine...",
  "table.resizeColumn": "Spremeni velikost stolpca",
  "table.sortAscending": "Razvrsti naraščajoče",
  "table.sortDescending": "Razvrsti padajoče",
  "tag.actions": "Dejanja",
  "tag.hideButtonLabel": "Prikaži manj",
  "tag.noTags": "Nič",
  "tag.showAllButtonLabel": "Prikaž vse ({tagCount, number})",
  "toast.clearAll": "Počisti vse",
  "toast.collapse": "Strni",
  "toast.showAll": "Prikaži vse"
}
